export function Carousel() {
  const elem = document.querySelectorAll(".carousel")

  elem.forEach((element) => {
    const carousel = {
      index: 0,
    }

    const slides = element.querySelectorAll(".carousel__slide")
    const dots = element.querySelectorAll("span[data-slider-dot]")

    function showSlides(n) {
      if (n > slides.length - 1) {
        return 0
      }
      if (n < 0) {
        return slides.length - 1
      }
      return n
    }

    function slideChange(event, direction, index) {
      const evt = new CustomEvent("slide-change", {
        detail: {
          direction,
          dotIndex: index,
          event,
        },
        bubbles: true,
      })
      element.dispatchEvent(evt)
    }

    element.addEventListener("click", (event) => {
      if (event.target.matches(".carousel__prev")) slideChange(event, "back")
    })

    element.addEventListener("click", (event) => {
      if (event.target.matches(".carousel__next")) slideChange(event, "forward")
    })

    element.addEventListener("slide-change", (e) => {
      if (e.detail.direction === "back") {
        carousel.index -= 1
        carousel.index = showSlides(carousel.index)
      }
      if (e.detail.direction === "forward") {
        carousel.index += 1
        carousel.index = showSlides(carousel.index)
      }
      if (e.detail.direction === "dot") {
        carousel.index = e.detail.dotIndex
        carousel.index = showSlides(carousel.index)
      }
    })

    slides.forEach((slide, i) => {
      element.addEventListener("slide-change", () => {
        if (carousel.index === i) {
          slide.classList.add("active")
        } else {
          slide.classList.remove("active")
        }
      })
    })

    dots.forEach((dot, i) => {
      dot.addEventListener("click", (event) => {
        slideChange(event, "dot", i)
      })

      element.addEventListener("slide-change", () => {
        if (carousel.index === i) {
          dot.classList.add("active")
        } else {
          dot.classList.remove("active")
        }
      })
    })
  })

  // move '.carousel__slideshow .carousel__controls' into '.homepage-hero--cta'
  const heroCtas = document.querySelectorAll(
    ".homepage-hero .homepage-hero--cta",
  )
  document.querySelectorAll(".carousel__slideshow").forEach((slideshow) => {
    const controls = slideshow.querySelector(".carousel__controls")

    if (controls) {
      controls.classList.remove("hero--inner")
      heroCtas.forEach((heroCta) => {
        const clonedControls = controls.cloneNode(true)
        clonedControls.classList.remove("hidden")
        heroCta.appendChild(clonedControls)
      })
    }
  })
}
